import { formatUnits, parseUnits } from '@ethersproject/units';

export const increaseByPercent = (number, percent = 50) => {
  const onePercent = number.div(100);

  return number.add(onePercent.mul(percent));
};
export function toWei(value) {
  return parseUnits(String(value), 'ether');
}

export const bigIntToInt = (value) => {
  if (!!Number(value)) {
    return parseInt(value) / 1e18;
  }
};

export function fromWei(balance, unitName = 'ether') {
  return formatUnits(String(balance), unitName);
}

export const round = (value, nums = 1) => {
  const rounded = Math.round(value * 10) / 10;

  if (rounded % 1 === 0) {
    return rounded.toString();
  } else {
    return rounded.toFixed(nums);
  }
}

export const formatNumberWithSpaces = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '--';

  // Округляем до целого числа
  const integerValue = Math.floor(value);
  
  // Форматируем с пробелами в качестве разделителей тысяч
  return integerValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
